import moment from 'moment';

export const PERIODS = {
  LAST_7_DAYS: {
    key: 'LAST_7_DAYS',
    name: '7 days',
    aggregation: 'day',
    from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD')
  },
  LAST_30_DAYS: {
    key: 'LAST_30_DAYS',
    name: '30 days',
    aggregation: 'week',
    from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD')
  },
  LAST_90_DAYS: {
    key: 'LAST_90_DAYS',
    name: '90 days',
    aggregation: 'week',
    from: moment().subtract(90, 'days').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD')
  }
};

export const getDefaultPeriod = periodKey => {
  return PERIODS[periodKey] || PERIODS.LAST_7_DAYS;
};

export const DEFAULT_PERIOD = PERIODS.LAST_7_DAYS;
